import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import Editor from '@/components/editor';
import Params from '@/views/template/template/components/params';
export default {
  name: 'template-editor',
  components: {
    Editor: Editor
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    isPreView: {
      default: function _default() {
        return false;
      }
    },
    onlyRead: {
      default: function _default() {
        return false;
      }
    },
    editorComponents: {
      default: function _default() {
        return false;
      }
    },
    paramListLoading: {
      default: function _default() {
        return false;
      }
    },
    id: {
      default: undefined
    },
    copy: {
      default: function _default() {
        return false;
      }
    },
    confirmId: {
      default: function _default() {
        return undefined;
      }
    },
    isInCorrespondence: {
      default: function _default() {
        return false;
      }
    },
    toolFixed: {
      default: function _default() {
        return false;
      }
    },
    taskId: {
      default: function _default() {
        return undefined;
      }
    },
    value: {
      default: function _default() {
        return {};
      }
    },
    defaultEditorVal: {
      default: function _default() {
        return '<p>若要绑定函证模板元素（编辑模式下），请使用英文格式的<span style="color:hsl(0, 75%, 60%);">{{}}</span>符号包住元素名称，如<span style="color:hsl(0, 75%, 60%);">{{元素名称1}}</span><span style="color:hsl(0, 0%, 0%);">，系统将会自动替换相关内容，表格将会强制占据一行</span></p>';
      }
    },
    params: {
      default: function _default() {
        return [];
      }
    },
    loading: {
      default: function _default() {
        return false;
      }
    },
    updateParam: {
      default: function _default() {
        return function () {};
      }
    },
    getSubjectOptions: {
      default: function _default() {
        return function () {};
      }
    },
    getParamDetail: {
      default: function _default() {
        return function () {};
      }
    },
    removeParam: {
      default: function _default() {
        return undefined;
      }
    },
    createParam: {
      default: function _default() {
        return undefined;
      }
    }
  },
  computed: {
    isCopy: function isCopy() {
      return this.copy;
    }
  },
  watch: {
    value: {
      handler: function handler(val) {
        this.form = val;
        this.editorVal = val.editorVal;
      },
      immediate: true
    },
    form: function form() {
      this.$emit('change', this.form);
    },
    params: {
      handler: function handler(val) {
        this.currentTableData = val;
      },
      immediate: true
    }
  },
  data: function data() {
    return {
      form: {
        ctIssue: false,
        share: false,
        use: false,
        belong: '',
        revise: '',
        desc: '',
        Items: [],
        name: '',
        editorVal: this.defaultEditorVal,
        createDate: undefined,
        updateDate: undefined,
        from: undefined
      },
      editorVal: this.defaultEditorVal,
      template: null,
      rules: {
        name: [{
          required: true,
          message: '请输入模板名称',
          trigger: 'change'
        }],
        desc: [{
          required: true,
          message: '请输入模板说明',
          trigger: 'change'
        }],
        editorVal: [{
          required: true,
          message: '请输入函证内容',
          trigger: 'change'
        }]
      },
      currentTableData: [],
      paramLoading: false
    };
  },
  methods: {
    getTableHeaders: function getTableHeaders(row) {
      if (row.header) {
        return row.header.split('|');
      }
      return [];
    },
    getTableParams: function getTableParams(data) {
      if (data) {
        var d = JSON.parse(JSON.stringify(data));
        return d.split('|');
      }
      return [];
    },
    updateEditor: function updateEditor(val) {
      this.form.editorVal = val;
    },
    getEditorVal: function getEditorVal() {
      return this.form.editorVal;
    },
    getTableData: function getTableData() {
      return this.currentTableData;
    },
    remove: function remove(item, index) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$$confirm('确定删除?');
            case 1:
              if (!(_this.removeParam && _this.confirmId)) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return _this.removeParam(item);
            case 2:
              _context.n = 4;
              break;
            case 3:
              _this.dataChange('remove', _this.currentTableData[index]);
              _this.currentTableData.splice(index, 1);
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    dataChange: function dataChange(type, data) {
      this.$emit('paramsChange', type, data, this.currentTableData);
    },
    create: function create() {
      var _arguments = arguments,
        _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var type, item, index, isCreate, _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, data, params;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              type = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 'create';
              item = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
              index = _arguments.length > 2 ? _arguments[2] : undefined;
              isCreate = type === 'create' || type === 'copy';
              _context2.n = 1;
              return _this2.$awaitTo(_this2.$dialog(Params, {
                dialog: {
                  title: isCreate ? '新增' : '编辑',
                  appendToBody: _this2.isInCorrespondence,
                  modalAppendToBody: _this2.isInCorrespondence,
                  width: '850px'
                },
                props: {
                  type: isCreate ? 'create' : type,
                  data: item,
                  isInCorrespondence: _this2.isInCorrespondence,
                  taskId: _this2.taskId,
                  confirmId: _this2.confirmId,
                  updateParam: _this2.updateParam,
                  getSubjectOptions: _this2.getSubjectOptions,
                  getParamDetail: _this2.getParamDetail,
                  createParam: _this2.createParam
                }
              }, function (template) {
                _this2.template = template;
              }));
            case 1:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              data = _yield$_this2$$awaitT2[1];
              _this2.template = null;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              if (!(_this2.isInCorrespondence && _this2.confirmId)) {
                if (isCreate) {
                  _this2.currentTableData.push(data);
                  _this2.dataChange('create', data);
                } else {
                  params = _objectSpread(_objectSpread({}, item), data);
                  _this2.currentTableData.splice(index, 1, params);
                  _this2.dataChange('update', params);
                }
              }
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    checkForm: function checkForm() {
      return this.$refs.form.validate();
    }
  },
  mounted: function mounted() {}
};